import React, { Component } from 'react';
import { Button, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select, message } from 'antd';
import { Message } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

function formatNumberInputValue(value) {
    if (value === undefined || value === null || value === '') {
        return undefined;
    }
    const numberValue = Number(value);
    return Number.isNaN(numberValue) ? undefined : numberValue;
}

class AddOrEditRuleMasterModalDialog extends Component {
    getActionFromMode(mode) {
        if (mode === 'ADD') {
            return 'Add';
        }
        if (mode === 'COPY') {
            return 'Copy';
        }
        return 'Edit';
    }

    componentDidUpdate() {
        const {
            saveRuleMasterActionStatus,
            saveRuleMasterActionResp,
        } = this.props;
        const { mode } = this.props.addOrEditRuleMasterModal;

        if (saveRuleMasterActionStatus === ACTION_STATUS.SUCCESS) {
            message.success(this.getActionFromMode(mode) + ' Rule Master succeeded.');
            this.props.initSaveRuleMasterActionStatus();
            this.props.resetAddOrEditRuleMasterModal();
            this.props.loadRuleMaster();
        }
        if (saveRuleMasterActionStatus === ACTION_STATUS.ERROR) {
            const errMsg = saveRuleMasterActionResp && saveRuleMasterActionResp.respMessage
                ? saveRuleMasterActionResp.respMessage
                : this.getActionFromMode(mode) + ' Rule Master failed.';
            message.error(errMsg);
            this.props.initSaveRuleMasterActionStatus();
        }
    }

    onInputChange = ({ name, value }) => {
        this.props.addOrEditRuleMasterChangeInput({ name, value });
    };

    submitSaveRuleMasterModal = () => {
        const { mode, fields } = this.props.addOrEditRuleMasterModal;
        this.props.form.validateFields(err => {
            if (err) {
                return;
            }
            this.props.saveRuleMaster({
                ...fields,
                mode,
            });
        });
    };

    renderTextInput(fieldName, label, required) {
        const { getFieldDecorator } = this.props.form;
        const value = this.props.addOrEditRuleMasterModal.fields[fieldName];
        return (
            <FormItem {...formItemLayout} label={label}>
                {getFieldDecorator(fieldName, {
                    initialValue: value,
                    rules: [{ required, message: 'Please input ' + label }],
                })(
                    <Input
                        style={{ width: 300, marginLeft: 10 }}
                        placeholder={label}
                        onChange={e => this.onInputChange({ name: fieldName, value: e.target.value })}
                    />
                )}
            </FormItem>
        );
    }

    renderNumberInput(fieldName, label, required) {
        const { getFieldDecorator } = this.props.form;
        const value = this.props.addOrEditRuleMasterModal.fields[fieldName];
        return (
            <FormItem {...formItemLayout} label={label}>
                {getFieldDecorator(fieldName, {
                    initialValue: formatNumberInputValue(value),
                    rules: [{ required, message: 'Please input ' + label }],
                })(
                    <InputNumber
                        style={{ width: 300, marginLeft: 10 }}
                        placeholder={label}
                        onChange={val => this.onInputChange({ name: fieldName, value: val })}
                    />
                )}
            </FormItem>
        );
    }

    renderSelect(fieldName, label, options, required) {
        const { getFieldDecorator } = this.props.form;
        const value = this.props.addOrEditRuleMasterModal.fields[fieldName];
        return (
            <FormItem {...formItemLayout} label={label}>
                {getFieldDecorator(fieldName, {
                    initialValue: value,
                    rules: [{ required, message: 'Please select ' + label }],
                })(
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        style={{ width: 300, marginLeft: 10 }}
                        placeholder={'Please select ' + label}
                        onChange={val => this.onInputChange({ name: fieldName, value: val })}
                    >
                        {options}
                    </Select>
                )}
            </FormItem>
        );
    }

    renderDatePicker(fieldName, label) {
        const { getFieldDecorator } = this.props.form;
        const value = this.props.addOrEditRuleMasterModal.fields[fieldName];
        return (
            <FormItem {...formItemLayout} label={label}>
                {getFieldDecorator(fieldName, {
                    initialValue: value,
                })(
                    <DatePicker
                        style={{ width: 300, marginLeft: 10 }}
                        onChange={date => this.onInputChange({ name: fieldName, value: date })}
                    />
                )}
            </FormItem>
        );
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            categoryOptions,
            statusOptions,
            fundOptions,
            assetClassOptions,
            countryCodeDOArray,
            addOrEditRuleMasterModal,
            saveRuleMasterActionStatus,
            saveRuleMasterActionResp,
        } = this.props;

        const countryOptions = [
            <Option key="All" value="All">All</Option>,
            ...(countryCodeDOArray || [])
                .slice()
                .sort((a, b) => (a.countryDesc || '').localeCompare(b.countryDesc || ''))
                .map(country => (
                    <Option key={country.countryDesc} value={country.countryDesc}>
                        {country.countryDesc}
                    </Option>
                )),
        ];

        const assetClassOptionsWithAll = [
            <Option key="All" value="All">All</Option>,
            <Option key="All_ExcludeCCY" value="All_ExcludeCCY">All_ExcludeCCY</Option>,
            ...(assetClassOptions || []),
        ];

        const exposureTypeOptions = [
            'AbsGross',
            'GrossLong',
            'GrossShort',
            'AbsNet',
            'NetLong',
            'NetShort',
        ].map(item => (
            <Option key={item} value={item}>
                {item}
            </Option>
        ));

        const exposureMeasureOptions = [
            'Position',
            'MarketValueLocal',
            'MarketValueUSD',
            'PMSF_NAVUSD',
            'PCF_NAVUSD',
            'VCC_NAVUSD',
        ].map(item => (
            <Option key={item} value={item}>
                {item}
            </Option>
        ));

        const exposureMetricOptions = [
            'Pct_Issued Share',
            'Position',
            'MarketValueLocal',
            'MarketValueUSD',
            'Pct_FundNAVUSD',
        ].map(item => (
            <Option key={item} value={item}>
                {item}
            </Option>
        ));

        const {
            isOpened,
            mode,
            fields,
        } = addOrEditRuleMasterModal;

        const modalTitle = this.getActionFromMode(mode) + ' Rule Master';
        const isSubmitLoading = saveRuleMasterActionStatus === ACTION_STATUS.LOGINING;
        const respErrMsg = saveRuleMasterActionStatus === ACTION_STATUS.ERROR && saveRuleMasterActionResp
            ? saveRuleMasterActionResp.respMessage
            : null;

        return (
            <div>
                <Modal
                    title={modalTitle}
                    centered
                    width={1100}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetAddOrEditRuleMasterModal()}
                    footer={[
                        <Button key="Cancel" onClick={() => this.props.resetAddOrEditRuleMasterModal()}>
                            Cancel
                        </Button>,
                        <Button key="Save" type="primary" loading={isSubmitLoading} onClick={() => this.submitSaveRuleMasterModal()}>
                            Save
                        </Button>,
                    ]}
                >
                    <Form layout="horizontal">
                        <Row gutter={24}>
                            <Col span={12}>{this.renderTextInput('ruleId', 'Rule ID', true)}</Col>
                            <Col span={12}>{this.renderSelect('status', 'Status', statusOptions, true)}</Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>{this.renderSelect('category', 'Category', categoryOptions.filter(e => e.key !== 'All'), true)}</Col>
                            <Col span={12}>{this.renderSelect('fund', 'Fund', fundOptions, true)}</Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>{this.renderSelect('country', 'Country', countryOptions, false)}</Col>
                            <Col span={12}>{this.renderSelect('assetClass', 'Asset Class', assetClassOptionsWithAll, false)}</Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>{this.renderSelect('expType', 'Exposure Type', exposureTypeOptions, false)}</Col>
                            <Col span={12}>{this.renderSelect('expMeasure', 'Exposure Measure', exposureMeasureOptions, false)}</Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>{this.renderSelect('expMetric', 'Exposure Metric', exposureMetricOptions, false)}</Col>
                            <Col span={12}>{this.renderTextInput('deadline', 'Deadline', false)}</Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>{this.renderNumberInput('reportThreshold', 'Report Threshold', true)}</Col>
                            <Col span={12}>{this.renderNumberInput('alertThreshold', 'Alert Threshold', true)}</Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>{this.renderDatePicker('effectiveFrom', 'Effective From')}</Col>
                            <Col span={12}>{this.renderDatePicker('effectiveTo', 'Effective To')}</Col>
                        </Row>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label="Remarks">
                                    {getFieldDecorator('remarks', {
                                        initialValue: fields.remarks,
                                    })(
                                        <TextArea
                                            rows={5}
                                            style={{ width: 300, marginLeft: 10 }}
                                            onChange={e => this.onInputChange({ name: 'remarks', value: e.target.value })}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    {
                        !!respErrMsg &&
                        <Message negative>
                            <Message.Header>Response Error Message</Message.Header>
                            <p>{respErrMsg}</p>
                        </Message>
                    }
                </Modal>
            </div>
        );
    }
}

const AddOrEditRuleMasterModalDialogForm = Form.create({ name: 'AddOrEditRuleMasterModalDialog' })(AddOrEditRuleMasterModalDialog);

export default AddOrEditRuleMasterModalDialogForm;
